import { createFileRoute } from "@tanstack/react-router";
import { LocaleContactRich } from "@/components/LocaleContactRich";
import { LOCALE_CONTACT } from "@/data/locale-pages-content";
import { LOCALE_PAGE_DEEP } from "@/data/locale-page-deep";
import { buildLocalePageHead } from "@/lib/locale-static-head";

export const Route = createFileRoute("/vi/contact")({
  loader: () => ({ h: buildLocalePageHead("contact", "vi") }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => (
    <LocaleContactRich content={LOCALE_CONTACT.vi} deep={LOCALE_PAGE_DEEP.vi.contact} />
  ),
});
